export default "__VITE_ASSET__ab97a244__"